<style src="css/test.css" scoped></style>
<template>
    <div style="padding-top: 1.4rem;background: #fff;">
        <newsTopBox title="测试"></newsTopBox>
        <div class="banner"></div>
        <div class="testBg" style="border-top: .01rem solid #eee">
            <div class="flexBox">
                <div class="testBgItem t1" @click="to(`testList?labelId=${scaleLabelList[0].labelId}`)">

                </div>
                <div class="testBgItem t2" @click="to(`testList?labelId=${scaleLabelList[1].labelId}`)">

                </div>
            </div>
            <div class="flexBox">
                <div class="testBgItem t3" @click="to(`testList?labelId=${scaleLabelList[2].labelId}`)">
                </div>
            </div>


        </div>

        <footerBox active="3"></footerBox>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import newsTopBox from 'components/newsTopBox'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'
    import footerBox from 'components/footer'
    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                // status: false,
                scaleLabelList:[]
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
            footerBox,
            newsTopBox,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            to(n) {
                this.$router.push(`/${n}`)
            },
            async getScaleLabelList() {
                let data = await getSources("/bear-scale/api/scaleHomePage/getScaleLabelList.json", {});
                if (data.status === 0) {
                    this.scaleLabelList = data.scaleLabelList
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {
            this.getScaleLabelList()
            // setInterval(()=>{
            //     this.status=!this.status
            // },1000)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/test.vue?a24a67b2